<template>
  <router-view />
</template>

<script>
export default {
  name: 'App',
  created() {
    //console.log('app created', this.$cookie.get('Card_page_source'));
  },
  mounted() {
    //console.log('app mounted');

    /* 解决360浏览器下backspace会返回上一页 (影响录入页描述部分暂不开启) */
    // document.onkeypress = this.$banBackSpace
    // document.onkeydown = this.$banBackSpace

  },
  updated() { },
  beforeDestroy() {
    this.$cookie.delete('Card_page_source');
  },
  destroyed() { },
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue